// ----------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code
// EDIT THE CORRESPONDENT .ts FILE INSTEAD

export const STABLE_COINS = [
    'USDT',
    'USDC',
    'DAI',
    'USDE',
    'FDUSD',
    'USDB',
    'BUSD',
];
